"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var _jquery = require("jquery");
var _default = exports.default = {
  getTaskType: function getTaskType(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsTaskType/page',
      method: 'get',
      params: params
    });
  },
  xyXhsTask: function xyXhsTask(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsTask/page',
      // 小红书任务列表
      method: 'get',
      params: params
    });
  },
  addTask: function addTask(data) {
    return (0, _requestPIM.default)({
      url: '/xyXhsTask/saveOrUpdate',
      method: 'post',
      data: data
    });
  },
  changeTaskSort: function changeTaskSort(data) {
    return (0, _requestPIM.default)({
      url: '/xyXhsTask/saveOrUpdateSort',
      method: 'post',
      data: data
    });
  },
  getTaskDetail: function getTaskDetail(id) {
    return (0, _requestPIM.default)({
      url: '/xyXhsTask/' + id,
      method: 'get'
    });
  },
  changeTaskStatus: function changeTaskStatus(data) {
    return (0, _requestPIM.default)({
      url: '/xyXhsTask/updateStatus',
      method: 'post',
      data: data
    });
  },
  xyXhsUserPost: function xyXhsUserPost(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsUserPost/page',
      // 帖子列表
      method: 'get',
      params: params
    });
  },
  getPostDetail: function getPostDetail(id) {
    return (0, _requestPIM.default)({
      url: '/xyXhsUserPost/' + id,
      method: 'get'
    });
  },
  postAudit: function postAudit(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsPostAudit/page',
      // 审核列表
      method: 'get',
      params: params
    });
  },
  AddPostAudit: function AddPostAudit(data) {
    return (0, _requestPIM.default)({
      url: '/xyXhsPostAudit/updateStatus',
      method: 'post',
      data: data
    });
  },
  getRewardNum: function getRewardNum(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsPostAudit/getRewardNum',
      method: 'get',
      params: params
    });
  },
  rewardAll: function rewardAll(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsPostAudit/rewardAll',
      // 批量发放
      method: 'get',
      params: params
    });
  },
  rewardById: function rewardById(id) {
    return (0, _requestPIM.default)({
      url: '/xyXhsPostAudit/rewardAll?id=' + id,
      // 批量发放
      method: 'get'
    });
  },
  getofficer: function getofficer(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficer/page',
      // 种草官列表
      method: 'get',
      params: params
    });
  },
  addOfficer: function addOfficer(data) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficer/saveOrUpdate',
      method: 'post',
      data: data
    });
  },
  officerLog: function officerLog(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficerRecord/page',
      // 种草官日志列表
      method: 'get',
      params: params
    });
  },
  officerRewardLog: function officerRewardLog(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficerReward/page',
      // 种草官日志列表  
      method: 'get',
      params: params
    });
  },
  changeOfficerStatus: function changeOfficerStatus(data) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficer/updateStatus',
      method: 'post',
      data: data
    });
  },
  exportOffircer: function exportOffircer(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficer/exportList',
      method: 'get',
      params: params,
      responseType: 'blob'
    });
  },
  importOfficer: function importOfficer(data) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficer/importList',
      method: 'post',
      data: data
    });
  },
  getOfficerDetail: function getOfficerDetail(id) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficer/' + id,
      method: 'get'
    });
  },
  getOffterTask: function getOffterTask(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficerTask/page',
      method: 'get',
      params: params
    });
  },
  addOfficerTask: function addOfficerTask(data) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficerTask/saveOrUpdate',
      method: 'post',
      data: data
    });
  },
  getOfficerTaskDetail: function getOfficerTaskDetail(id) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficerTask/' + id,
      method: 'get'
    });
  },
  changeOfficerTaskStatus: function changeOfficerTaskStatus(data) {
    return (0, _requestPIM.default)({
      url: '/xyXhsOfficerTask/updateStatus',
      method: 'post',
      data: data
    });
  },
  // 设置黑名单
  setBlackList: function setBlackList(data) {
    return (0, _requestPIM.default)({
      url: '/xyXhsBlack//xyXhsBlackSave',
      method: 'post',
      data: data
    });
  },
  // 黑名单列表
  getBlackList: function getBlackList(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsBlack/page',
      method: 'get',
      params: params
    });
  },
  // 删除黑名单
  delBlackList: function delBlackList(params) {
    return (0, _requestPIM.default)({
      url: '/xyXhsBlack/xyXhsBlackDelete',
      method: 'get',
      params: params
    });
  },
  // 查询会员手机号/卡号
  queryMember: function queryMember(params) {
    return (0, _requestPIM.default)({
      url: '/xyUserCards/page',
      method: 'get',
      params: params
    });
  },
  exportPostList: function exportPostList(params) {
    return (0, _requestPIM.default)({
      url: 'xyXhsUserPost/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    });
  },
  // 帖子列表奖励信息
  getPostRewardInfo: function getPostRewardInfo(params) {
    return (0, _requestPIM.default)({
      url: 'xyXhsPostReward/page',
      method: 'get',
      params: params
    });
  }
};